module.exports = __webpack_public_path__ + "5cb8280af715dbe3c9aebaea6afc8601.pdf";